module.exports = __webpack_public_path__ + "assets/img/xian.55a7494e.png";